
	import { Component, Vue } from 'vue-property-decorator';
	import { serverProps } from '@/Common/Environment/const';

	import aps from '@/HostApp/store/ApsModules/ApsModule';
	import VueIframe from '@/HostApp/ui/system/VueIframe.vue';

	import helpCenterServiceModule from '@/HostApp/services/HelpCenterService/HelpCenterServiceModule';

	@Component({
		components: { VueIframe }
	})
	export default class HelpCenterNode extends Vue {
		protected get isHelpCenterEnabled(): boolean {
			return helpCenterServiceModule.isEnabled || false;
		}

		protected get isHelpCenterOpened(): boolean {
			return helpCenterServiceModule.isHelpCenterOpened;
		}

		protected get helpMenu(): APS.IMenuItems | undefined {
			return serverProps.helpMenu;
		}

		protected get viewId(): string {
			const { context = [] } = aps.navigation?.tree || {};
			return context.length ? context[context.length - 1]?.viewId || '' : '';
		}

		protected get vueWorkspace(): boolean {
			return !!aps.navigation.vueWorkspace;
		}

		protected onDrawerClosed(): void {
			helpCenterServiceModule.setIsHelpCenterOpened(false);
		}
	}
